import React from 'react';
import { Car, Calendar, Gauge, Truck, Clock } from 'lucide-react';

/**
 * Компонент параметров автомобиля для калькулятора расхода топлива
 */
const VehicleParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/50 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Car className="w-5 h-5 mr-2 text-blue-500" />
        Данные об автомобиле
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Марка автомобиля */}
        <div>
          <label htmlFor="vehicleInfo.make" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Марка автомобиля
          </label>
          <input
            type="text"
            id="vehicleInfo.make"
            name="vehicleInfo.make"
            value={formData.vehicleInfo.make}
            onChange={handleInputChange}
            className={`form-input w-full ${errors['vehicleInfo.make'] ? 'input-error' : ''}`}
            placeholder="Например: Lada, Kia, Volkswagen"
          />
          {errors['vehicleInfo.make'] && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors['vehicleInfo.make']}
            </p>
          )}
        </div>

        {/* Модель автомобиля */}
        <div>
          <label htmlFor="vehicleInfo.model" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Модель автомобиля
          </label>
          <input
            type="text"
            id="vehicleInfo.model"
            name="vehicleInfo.model"
            value={formData.vehicleInfo.model}
            onChange={handleInputChange}
            className={`form-input w-full ${errors['vehicleInfo.model'] ? 'input-error' : ''}`}
            placeholder="Например: Granta, Rio, Polo"
          />
          {errors['vehicleInfo.model'] && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors['vehicleInfo.model']}
            </p>
          )}
        </div>

        {/* Год выпуска */}
        <div>
          <label htmlFor="vehicleInfo.year" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calendar className="w-4 h-4 mr-2 text-blue-500" />
            Год выпуска
          </label>
          <input
            type="text"
            id="vehicleInfo.year"
            name="vehicleInfo.year"
            value={formData.vehicleInfo.year}
            onChange={handleInputChange}
            className={`form-input w-full ${errors['vehicleInfo.year'] ? 'input-error' : ''}`}
            placeholder="Например: 2023"
          />
          {errors['vehicleInfo.year'] && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors['vehicleInfo.year']}
            </p>
          )}
        </div>

        {/* Объем двигателя */}
        <div>
          <label htmlFor="vehicleInfo.engineVolume" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Gauge className="w-4 h-4 mr-2 text-blue-500" />
            Объем двигателя (л)
          </label>
          <input
            type="text"
            id="vehicleInfo.engineVolume"
            name="vehicleInfo.engineVolume"
            value={formData.vehicleInfo.engineVolume}
            onChange={handleInputChange}
            className={`form-input w-full ${errors['vehicleInfo.engineVolume'] ? 'input-error' : ''}`}
            placeholder="Например: 1.6"
          />
          {errors['vehicleInfo.engineVolume'] && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors['vehicleInfo.engineVolume']}
            </p>
          )}
        </div>

        {/* Объем бака */}
        <div>
          <label htmlFor="vehicleInfo.fuelTankCapacity" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Truck className="w-4 h-4 mr-2 text-blue-500" />
            Объем топливного бака (л)
          </label>
          <input
            type="text"
            id="vehicleInfo.fuelTankCapacity"
            name="vehicleInfo.fuelTankCapacity"
            value={formData.vehicleInfo.fuelTankCapacity}
            onChange={handleInputChange}
            className={`form-input w-full ${errors['vehicleInfo.fuelTankCapacity'] ? 'input-error' : ''}`}
            placeholder="Например: 50"
          />
          {errors['vehicleInfo.fuelTankCapacity'] && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors['vehicleInfo.fuelTankCapacity']}
            </p>
          )}
        </div>

        {/* Средняя скорость */}
        <div>
          <label htmlFor="vehicleInfo.averageSpeed" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-2 text-blue-500" />
            Средняя скорость (км/ч)
          </label>
          <input
            type="text"
            id="vehicleInfo.averageSpeed"
            name="vehicleInfo.averageSpeed"
            value={formData.vehicleInfo.averageSpeed}
            onChange={handleInputChange}
            className={`form-input w-full ${errors['vehicleInfo.averageSpeed'] ? 'input-error' : ''}`}
            placeholder="Например: 60"
          />
          {errors['vehicleInfo.averageSpeed'] && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors['vehicleInfo.averageSpeed']}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Средняя скорость в городе 30-40 км/ч, на трассе 80-90 км/ч
          </p>
        </div>
      </div>

      <div className="bg-gray-100 dark:bg-gray-700/50 p-3 mt-4 rounded-lg border border-gray-200 dark:border-gray-600 text-sm text-gray-700 dark:text-gray-300">
        <div className="flex items-start">
          <Car className="w-5 h-5 mr-3 mt-0.5 text-gray-500 dark:text-gray-400" />
          <div>
            <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Необязательные данные
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              Заполнение этих полей позволит рассчитать дополнительные параметры: запас хода на полном баке и время в пути.
              Эти данные также сохранятся при добавлении автомобиля в избранное.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleParametersSection;